import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Col,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Input,
  Label,
  FormGroup
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import classnames from "classnames";
import { toast } from "react-toastify";

import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import bell from "../../assets/images/svg/bell.svg";

import dummyImg from "../../assets/images/users/user-dummy-img.jpg";
import companyImg from "../../assets/images/users/logo-sm.png";

import { api } from "../../config";
import io from "socket.io-client";

import {
  getNotifications as onGetNotifications,
  updateNotification as onGetUpdateNotification,
  getUsers as onGetUsers,
} from "../../slices/thunks";

import { hasPermission } from "../../config/permissions";

//SimpleBar
import SimpleBar from "simplebar-react";
import axios from "axios";
import { APIClient } from "../../helpers/api_helper";
const apiClient = new APIClient();

const NotificationDropdown = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // useMemo-оор нэг удаа parse хийж, render бүр шинэ object үүсгэхгүй
  const authUser = React.useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("authUser"));
    } catch {
      return null;
    }
  }, []);

  const [notificationsList, setNotificationsList] = useState([]);
  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState(0);
  const [activeTab, setActiveTab] = useState("1");
  const [prevUnreadCount, setPrevUnreadCount] = useState(0);
  const [soundAllowed, setSoundAllowed] = useState(false);

  // Alert popup states
  const [alertModal, setAlertModal] = useState(false);
  const [currentAlert, setCurrentAlert] = useState(null);
  const [fbText, setFbText] = useState("");
  const [pollOpt, setPollOpt] = useState("");
  const [isMarkingRead, setIsMarkingRead] = useState(false);

  const prevUnreadCountRef = useRef(0);
  const prevNotifIdsRef = useRef(new Set());
  const [blockRecalc, setBlockRecalc] = useState(false);

  // Bottom-right popup notifications state
  const [popupNotifications, setPopupNotifications] = useState([]);

  const getTunnel = React.useCallback(() => {
    if (authUser?.company === "TILogistic") {
      if (authUser?.section === "Санхүүгийн хэлтэс") return "Тээврийн газар";
      if (authUser?.role === "Ахлах гаалийн бүртгэгдсэн мэргэжилтэн" ||
          authUser?.role === "Гаалийн бүртгэгдсэн мэргэжилтэн") return "Тээврийн газар";
      return authUser?.department || "null";
    }
    if (authUser?.type === "Терминалын газрын хэрэглэгч") return "Терминалын газар";
    if (authUser?.type === "Тээврийн газрын хэрэглэгч") return "Тээврийн газар";
    return "null";
  }, [authUser?.company, authUser?.section, authUser?.role, authUser?.department, authUser?.type]);

  // Зөвхөн тодорхой хэлтсийн ажилтнуудад popup харуулна
  const isTargetUser = authUser && (
    authUser.department === "Тээврийн газар" ||
    authUser.section === "Тээврийн газар" ||
    (authUser.department === "Захиргаа удирдлага, санхүүгийн газар" && authUser.section === "Санхүүгийн хэлтэс")
  );

  // Browser notification permission хүсэх
  useEffect(() => {
    if (isTargetUser && "Notification" in window && Notification.permission === "default") {
      Notification.requestPermission();
    }
  }, [isTargetUser]);

  useEffect(() => {
    if (currentAlert && authUser) {
      const myR = currentAlert.recipients?.find(r => r.userId.toString() === authUser._id.toString());
      if (myR && myR.isRead) {
        setFbText(myR.responseText || "");
        setPollOpt(myR.selectedOption || "");
      } else {
        setFbText("");
        setPollOpt("");
      }
    }
  }, [currentAlert, authUser?._id]);

  const handleAcknowledgeAlert = async () => {
    if (!currentAlert || !currentAlert._id) return;

    // Determine if we need to call /respond or standard update string
    const isSpecialType = ["feedback", "poll"].includes(currentAlert.ntf_type);

    if (isSpecialType) {
      const payload = {
        ntfId: currentAlert._id,
        responseText: currentAlert.ntf_type === "feedback" ? fbText : undefined,
        selectedOption: currentAlert.ntf_type === "poll" ? pollOpt : undefined,
      };
      try {
        await axios.put(api.REAPI_URL + "/notifications/respond", payload, {
          headers: {
            "Authorization": "Bearer " + (authUser?.accessToken || "")
          }
        });
        dispatch(onGetUpdateNotification({ ids: [currentAlert._id], userId: authUser?._id }));
      } catch (err) {
        console.error("Error submitting feedback:", err);
      }
    } else {
      dispatch(onGetUpdateNotification({ ids: [currentAlert._id], userId: authUser?._id }));
    }

    setAlertModal(false);
    setFbText("");
    setPollOpt("");
  };

  const [isNotificationDropdown, setIsNotificationDropdown] = useState(false);
  const toggleNotificationDropdown = () => {
    setIsNotificationDropdown(!isNotificationDropdown);
  };

  const markSingleAsRead = React.useCallback((ntf) => {
    if (!ntf || !authUser) return;
    const isUnread = ntf.recipients?.some(
      (r) => r.userId?.toString() === authUser._id?.toString() && !r.isRead
    );
    if (!isUnread) return;

    setNotificationsList((prev) =>
      prev.map((n) =>
        n._id === ntf._id
          ? {
              ...n,
              recipients: n.recipients.map((r) =>
                r.userId?.toString() === authUser._id?.toString()
                  ? { ...r, isRead: true }
                  : r
              ),
            }
          : n
      )
    );
    setUnreadNotificationsCount((prev) => Math.max(0, prev - 1));
    dispatch(onGetUpdateNotification({ ids: [ntf._id], userId: authUser._id }));
  }, [authUser, dispatch]);

  const handleNotificationClick = (ntf) => {
    if (!ntf) return;
    markSingleAsRead(ntf);

    const bodyText = ntf.ntf_body || "";
    if (bodyText.includes("нэхэмжлэх авах хүсэлт илгээсэн")) {
      const ivNumber = bodyText.split(" ")[0];
      if (ivNumber) {
        navigate(`/oinvoices?search=${ivNumber}`);
        setIsNotificationDropdown(false);
      }
    } else if (
      bodyText.includes("баталгаажуулсан") ||
      bodyText.includes("хянаж эхэлсэн") ||
      bodyText.includes("татгалзсан")
    ) {
      if (bodyText.includes("нэхэмжлэх авах хүсэлтийг")) {
        const parts = bodyText.split(" ");
        const trackingNumber = parts[parts.length - 1];
        if (trackingNumber) {
          navigate(`/tracking?search=${trackingNumber}`);
          setIsNotificationDropdown(false);
        }
      }
    }
  };

  const selectNotificationLayoutState = (state) => state.Notification;
  const notificationData = createSelector(
    selectNotificationLayoutState,
    (state) => ({
      notifications: state.notifications,
      notificationsPage: state.notificationsPage,
      notificationsHasMore: state.notificationsHasMore,
      isNotificationsSuccess: state.isNotificationsSuccess,
      error: state.error,
    })
  );

  const { notifications, notificationsPage, notificationsHasMore, isNotificationsSuccess, error } =
    useSelector(notificationData);

  const [loadingMore, setLoadingMore] = useState(false);

  const selectLayoutState = (state) => state.Crm;
  const crmuserData = createSelector(selectLayoutState, (state) => ({
    crmusers: state.crmusers,
    isUserSuccess: state.isUserSuccess,
    error: state.error,
  }));

  const { crmusers, isUserSuccess } = useSelector(crmuserData);

  useEffect(() => {
    if (crmusers && !crmusers.length) {
      dispatch(onGetUsers());
    }
  }, [dispatch, crmusers]);

  useEffect(() => {
    const fetchNotifications = () => {
      const tunnel = getTunnel();

      dispatch(
        onGetNotifications({
          ntf_tunnel: tunnel,
        })
      );
    };

    fetchNotifications();

    // Socket.io Integration
    const socketUrl = new URL(api.REAPI_URL).origin;
    const socket = io(socketUrl, {
      path: "/api/socket.io",
      withCredentials: true,
      // Зөвхөн WebSocket ашиглана — HTTP polling нь корпорацийн
      // firewall/proxy-д блоклогддог тул packet loss гарна
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 2000,
      timeout: 10000,
    });

    socket.on("connect", () => {
      if (authUser && authUser._id) {
        socket.emit("registerUser", authUser._id);
      }
    });

    socket.on("newNotification", (ntf) => {
      // Whenever backend pushes a notification we fetch newest
      fetchNotifications();
    });

    return () => {
      socket.disconnect();
    };
  }, [dispatch, getTunnel, authUser?._id, authUser?.company, authUser?.department, authUser?.type]);

  useEffect(() => {
    const handleUserInteraction = () => setSoundAllowed(true);
    document.addEventListener("click", handleUserInteraction, { once: true });
    return () => document.removeEventListener("click", handleUserInteraction);
  }, []);

  useEffect(() => {
    if (isMarkingRead || blockRecalc) return;

    if (Array.isArray(notifications) && authUser) {
      const enrichedNotifications = notifications
        .filter((ntf) => {
          // If the array explicitly has recipients mapped, you MUST be in it to see it.
          // Otherwise, it's a general tunnel notification (if ntf_tunnel exists) 
          if (ntf.recipients && ntf.recipients.length > 0) {
            return ntf.recipients.some(r => r.userId.toString() === authUser._id.toString());
          } else if (ntf.ntf_tunnel && ntf.ntf_tunnel !== "null") {
            return ntf.sender_id !== authUser._id;
          }
          return false; // Safely hide orphaned notifications
        })
        .map((ntf) => {
          let senderName = ntf.sender_company || "N/A";
          let senderImage = companyImg;

          const isPrivilegedUser =
            hasPermission(authUser.role, "NOTIFICATION_PRIVILEGED_USERS") ||
            authUser.department === "Тээврийн газар" ||
            authUser.section === "Санхүүгийн хэлтэс" ||
            (authUser.notification_tunnels && authUser.notification_tunnels.length > 0);

          if (isPrivilegedUser) {
            if (ntf.sender_company !== "TILogistic") {
              senderName = ntf.sender_company || "N/A";
              senderImage = ntf.sender_image_url || dummyImg;
            } else {
              senderName = `${ntf.sender_last_name?.charAt(0).toUpperCase() || ""}.${ntf.sender_first_name || ""
                } | ${ntf.sender_company || "TILogistic"}`;
              senderImage = ntf.sender_image_url || dummyImg;
            }
          }

          return {
            ...ntf,
            sender_image: senderImage,
            sender_name: senderName,
          };
        });

      const unreadCount = enrichedNotifications.filter((ntf) =>
        ntf.recipients.some(
          (r) => r.userId.toString() === authUser._id.toString() && !r.isRead
        )
      ).length;

      if (unreadCount > prevUnreadCountRef.current) {
        // Шинэ (өмнө харагдаагүй) unread notification-уудыг олох
        const newNtfs = enrichedNotifications.filter((ntf) => {
          const isUnread = ntf.recipients.some(
            (r) => r.userId.toString() === authUser._id.toString() && !r.isRead
          );
          return isUnread && !prevNotifIdsRef.current.has(ntf._id?.toString());
        });

        // Check for unread warnings
        const unreadWarnings = newNtfs.filter((ntf) =>
          ["warning", "feedback", "poll"].includes(ntf.ntf_type)
        );

        if (unreadWarnings.length > 0) {
          setCurrentAlert(unreadWarnings[0]);
          setAlertModal(true);
        } else {
          toast.info(
            `Шинэ мэдэгдэл ирлээ! (${unreadCount - prevUnreadCountRef.current})`,
            {
              autoClose: 5000,
              closeButton: ({ closeToast }) => (
                <button
                  onClick={closeToast}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "#1077d8ff",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                >
                  ✖
                </button>
              ),
            }
          );
        }

        // Bottom-right popup — зөвхөн target хэрэглэгчдэд
        if (isTargetUser && newNtfs.length > 0) {
          const popups = newNtfs.map((ntf) => ({
            id: ntf._id?.toString() || Math.random().toString(),
            title: ntf.ntf_title || "Мэдэгдэл",
            body: ntf.ntf_body || "",
            sender: ntf.sender_name || "",
            date: ntf.ntf_date || new Date().toISOString(),
          }));
          setPopupNotifications((prev) => [...popups, ...prev]);

          // Browser minimize / focus алдсан үед Web Notification API ашиглана
          if ("Notification" in window && Notification.permission === "granted" &&
              (document.visibilityState === "hidden" || !document.hasFocus())) {
            popups.forEach((p) => {
              const n = new Notification(p.title, {
                body: p.body,
                icon: "/favicon.ico",
                tag: p.id,
                requireInteraction: true,
              });
              n.onclick = () => {
                window.focus();
                n.close();
              };
            });
          }
        }
      }

      // prevNotifIdsRef шинэчлэх (unread-уудын ID бүгд)
      const currentUnreadIds = new Set(
        enrichedNotifications
          .filter((ntf) => ntf.recipients.some((r) => r.userId.toString() === authUser._id.toString() && !r.isRead))
          .map((ntf) => ntf._id?.toString())
      );
      prevNotifIdsRef.current = currentUnreadIds;

      if (unreadCount > prevUnreadCountRef.current && soundAllowed) {
        const audio = new Audio("/sounds/notification.mp3");
        audio.play().catch((err) => console.log("Sound play error:", err));
      }

      prevUnreadCountRef.current = unreadCount;
      setUnreadNotificationsCount(unreadCount);
      setNotificationsList(enrichedNotifications);
    }
  }, [notifications, authUser, soundAllowed, isMarkingRead, blockRecalc]);

  const msgNtfs = notificationsList.filter(ntf => !["warning", "feedback", "poll"].includes(ntf.ntf_type));
  const alertNtfs = notificationsList.filter(ntf => ["warning", "feedback", "poll"].includes(ntf.ntf_type));

  const formatNotificationDate = (dateString) => {
    const now = new Date();
    const date = new Date(dateString);

    const diffMs = now - date;
    const diffSeconds = Math.floor(diffMs / 1000);
    const diffMinutes = Math.floor(diffSeconds / 60);
    const diffHours = Math.floor(diffMinutes / 60);

    if (diffHours < 12) {
      if (diffHours > 0) {
        return `${diffHours} цагийн өмнө`;
      } else if (diffMinutes > 0) {
        return `${diffMinutes} минутын өмнө`;
      } else {
        return `${diffSeconds} секундын өмнө`;
      }
    }

    // YYYY-MM-DD, HH:mm форматаар буцаах
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}, ${hours}:${minutes}`;
  };

  const handleDropdownOpen = () => {
    setSoundAllowed(true);
  };

  const markAllAsRead = async (e) => {
    e.stopPropagation();
    if (isMarkingRead) return;

    const unreadIds = notificationsList
      ?.filter((ntf) =>
        ntf.recipients.some(
          (r) => r.userId?.toString() === authUser._id?.toString() && r.isRead === false
        )
      )
      .map((ntf) => ntf._id);

    if (!unreadIds?.length) return;

    setBlockRecalc(true);
    setIsMarkingRead(true);
    setUnreadNotificationsCount(0);
    setNotificationsList((prevList) =>
      prevList.map((ntf) =>
        unreadIds.includes(ntf._id)
          ? {
              ...ntf,
              recipients: ntf.recipients.map((r) =>
                r.userId?.toString() === authUser._id?.toString()
                  ? { ...r, isRead: true }
                  : r
              ),
            }
          : ntf
      )
    );

    try {
      await dispatch(onGetUpdateNotification({ ids: unreadIds, userId: authUser._id })).unwrap();
      // Redux reducer шинэчилсний дараа refetch — 100% sync баталгаа
      dispatch(onGetNotifications({ ntf_tunnel: getTunnel() }));
    } catch (err) {
      console.log("Error marking as read", err);
    } finally {
      setIsMarkingRead(false);
      // blockRecalc state-аар useEffect-ийг дахин ажиллуулна
      setTimeout(() => setBlockRecalc(false), 600);
    }
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const loadMoreNotifications = async () => {
    if (loadingMore || !notificationsHasMore) return;
    setLoadingMore(true);
    try {
      await dispatch(onGetNotifications({
        ntf_tunnel: getTunnel(),
        page: (notificationsPage || 1) + 1,
        append: true,
      }));
    } finally {
      setLoadingMore(false);
    }
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isNotificationDropdown}
        toggle={toggleNotificationDropdown}
        className="topbar-head-dropdown ms-1 header-item"
      >
        <DropdownToggle
          type="button"
          tag="button"
          className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
          onClick={handleDropdownOpen}
        >
          <i className="bx bx-bell fs-22"></i>
          <span className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-info">
            {unreadNotificationsCount || 0}
            <span className="visually-hidden">уншаагүй мэдэгдэл</span>
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end p-0" style={{ borderRadius: "0 0 14px 14px", overflow: "hidden", boxShadow: "0 8px 32px rgba(0,0,0,0.13)", minWidth: 380 }}>
          <div style={{ background: "linear-gradient(135deg, #3d8ef8 0%, #1a57b7 100%)" }}>
            {/* Title + "Бүгдийг унших" */}
            <div style={{ padding: "16px 20px 12px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
              <div className="d-flex align-items-center gap-2" style={{ flexShrink: 0 }}>
                <div style={{ width: 34, height: 34, borderRadius: "50%", background: "rgba(255,255,255,.2)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <i className="bx bx-bell" style={{ color: "#fff", fontSize: 17 }}></i>
                </div>
                <span style={{ color: "#fff", fontWeight: 700, fontSize: 15 }}>Мэдэгдэл</span>
                {unreadNotificationsCount > 0 && (
                  <span style={{ background: "rgba(255,255,255,.25)", color: "#fff", borderRadius: 20, padding: "2px 10px", fontSize: 12, fontWeight: 700 }}>
                    {unreadNotificationsCount}
                  </span>
                )}
              </div>
              <span
                onClick={isMarkingRead ? null : markAllAsRead}
                style={{
                  display: "inline-flex", alignItems: "center", gap: 5,
                  background: "rgba(255,255,255,.15)", color: "#fff",
                  border: "1px solid rgba(255,255,255,.3)", borderRadius: 20,
                  padding: "5px 13px", fontSize: 12, fontWeight: 600,
                  cursor: isMarkingRead ? "not-allowed" : "pointer",
                  transition: "background .15s", whiteSpace: "nowrap", flexShrink: 0,
                }}
                title="Бүгдийг уншсанаар тэмдэглэх"
              >
                {isMarkingRead
                  ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ width: 11, height: 11, borderWidth: 2 }}></span>
                  : <i className="ri-check-double-line"></i>}
                Бүгдийг унших ({unreadNotificationsCount || 0})
              </span>
            </div>

            {/* Tabs */}
            <div style={{ display: "flex", padding: "0 16px", gap: 6 }}>
              {[
                { id: "1", label: "Нийт" },
                { id: "2", label: "Мэдэгдэл" },
                { id: "3", label: "Чухал мэдэгдэл" },
              ].map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => toggleTab(tab.id)}
                  style={{
                    border: "none", cursor: "pointer", padding: "7px 14px",
                    borderRadius: "8px 8px 0 0", fontSize: 13, fontWeight: 600,
                    transition: "all .15s",
                    background: activeTab === tab.id ? "#fff" : "rgba(255,255,255,.12)",
                    color: activeTab === tab.id ? "#1a57b7" : "rgba(255,255,255,.85)",
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="1" className="py-2 ps-2">
              <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
                {notificationsList && notificationsList.length > 0 ? (
                  notificationsList.map((ntf) => (
                    <div
                      key={ntf._id}
                      className="text-reset notification-item d-block dropdown-item position-relative"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleNotificationClick(ntf)}
                    >
                      <div className="d-flex">
                        <img
                          src={ntf?.sender_image || dummyImg} onError={(e) => { e.target.onerror = null; e.target.src = dummyImg; }}
                          className="me-3 rounded-circle avatar-xs"
                          alt="user-pic"
                        />
                        <div className="flex-grow-1">
                          <h6 className="mt-0 mb-1 fs-13 fw-semibold">
                            {ntf?.sender_name || "Unknown"}
                          </h6>
                          <div className="fs-13 text-muted">
                            <p
                              className={`mb-1 ${ntf.recipients.some(
                                (r) =>
                                  r.userId.toString() ===
                                  authUser._id.toString() && !r.isRead
                              )
                                  ? "text-info"
                                  : "text-muted"
                                }`}
                            >
                              {ntf.ntf_body}
                            </p>
                          </div>

                          <p className="mb-0 fs-11 fw-medium text-muted">
                            <span>
                              <i className="mdi mdi-clock-outline"></i>{" "}
                              {formatNotificationDate(ntf.ntf_date)}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <>
                    <div className="w-25 w-sm-50 pt-3 mx-auto">
                      <img
                        src={bell}
                        className="img-fluid"
                        alt="no-notification"
                      />
                    </div>
                    <div className="text-center pb-5 mt-2">
                      <h6 className="fs-18 fw-semibold lh-base">
                        Танд ирсэн мэдэгдэл байхгүй байна
                      </h6>
                    </div>
                  </>
                )}
              </SimpleBar>
            </TabPane>

            <TabPane tabId="2" className="py-2 ps-2">
              <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
                {msgNtfs && msgNtfs.length > 0 ? (
                  msgNtfs.map((ntf) => (
                    <div
                      key={ntf._id}
                      className="text-reset notification-item d-block dropdown-item position-relative"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleNotificationClick(ntf)}
                    >
                      <div className="d-flex">
                        <img
                          src={ntf?.sender_image || dummyImg} onError={(e) => { e.target.onerror = null; e.target.src = dummyImg; }}
                          className="me-3 rounded-circle avatar-xs"
                          alt="user-pic"
                        />
                        <div className="flex-grow-1">
                          <h6 className="mt-0 mb-1 fs-13 fw-semibold">
                            {ntf?.sender_name || "Unknown"}
                          </h6>
                          <div className="fs-13 text-muted">
                            <p
                              className={`mb-1 ${ntf.recipients.some(
                                (r) =>
                                  r.userId.toString() ===
                                  authUser._id.toString() && !r.isRead
                              )
                                  ? "text-info"
                                  : "text-muted"
                                }`}
                            >
                              {ntf.ntf_body}
                            </p>
                          </div>

                          <p className="mb-0 fs-11 fw-medium text-muted">
                            <span>
                              <i className="mdi mdi-clock-outline"></i>{" "}
                              {formatNotificationDate(ntf.ntf_date)}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <>
                    <div className="w-25 w-sm-50 pt-3 mx-auto">
                      <img
                        src={bell}
                        className="img-fluid"
                        alt="no-notification"
                      />
                    </div>
                    <div className="text-center pb-5 mt-2">
                      <h6 className="fs-18 fw-semibold lh-base">
                        Танд ирсэн мэдэгдэл байхгүй байна
                      </h6>
                    </div>
                  </>
                )}
              </SimpleBar>
            </TabPane>
            <TabPane tabId="3" className="py-2 ps-2">
              <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
                {alertNtfs && alertNtfs.length > 0 ? (
                  alertNtfs.map((ntf) => (
                    <div
                      key={ntf._id}
                      className="text-reset notification-item d-block dropdown-item position-relative bg-info-subtle"
                      onClick={() => {
                        markSingleAsRead(ntf);
                        setCurrentAlert(ntf);
                        setAlertModal(true);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="d-flex">
                        <img
                          src={ntf?.sender_image || dummyImg} onError={(e) => { e.target.onerror = null; e.target.src = dummyImg; }}
                          className="me-3 rounded-circle avatar-xs"
                          alt="user-pic"
                        />
                        <div className="flex-grow-1">
                          <h6 className="mt-0 mb-1 fs-13 fw-semibold text-info">
                            {ntf?.sender_name || "Unknown"}
                          </h6>
                          <div className="fs-13 text-muted">
                            <p
                              className={`mb-1 fw-bold ${ntf.recipients.some(
                                (r) =>
                                  r.userId.toString() ===
                                  authUser._id.toString() && !r.isRead
                              )
                                  ? "text-primary"
                                  : "text-dark"
                                }`}
                            >
                              {ntf.ntf_body}
                            </p>
                          </div>

                          <p className="mb-0 fs-11 fw-medium text-muted">
                            <span>
                              <i className="mdi mdi-clock-outline"></i>{" "}
                              {formatNotificationDate(ntf.ntf_date)}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <>
                    <div className="w-25 w-sm-50 pt-3 mx-auto">
                      <img src={bell} className="img-fluid" alt="user-pic" />
                    </div>
                    <div className="text-center pb-5 mt-2">
                      <h6 className="fs-18 fw-semibold lh-base">
                        Танд ирсэн чухал мэдэгдэл байхгүй байна{" "}
                      </h6>
                    </div>
                  </>
                )}
              </SimpleBar>
            </TabPane>
          </TabContent>

          {/* "Цааш" товч */}
          {notificationsHasMore && (
            <div style={{ padding: "10px 14px", borderTop: "1px solid #f0f4f8", background: "#f8fafc", textAlign: "center" }}>
              <button
                onClick={loadMoreNotifications}
                disabled={loadingMore}
                style={{
                  background: "linear-gradient(135deg, #3d8ef8 0%, #1a57b7 100%)",
                  color: "#fff", border: "none", borderRadius: 8,
                  padding: "7px 28px", fontSize: 13, fontWeight: 600,
                  cursor: loadingMore ? "not-allowed" : "pointer", opacity: loadingMore ? 0.7 : 1,
                }}
              >
                {loadingMore
                  ? <><span className="spinner-border spinner-border-sm me-2" style={{ width: 12, height: 12, borderWidth: 2 }}></span>Ачаалж байна...</>
                  : <><i className="ri-arrow-down-line me-1"></i>Цааш үзэх</>}
              </button>
            </div>
          )}
        </DropdownMenu>
      </Dropdown>

      {/* Warning Popup Modal */}
      <Modal
        isOpen={alertModal}
        centered
        backdrop="static"
        keyboard={false}
      >
        <ModalHeader toggle={() => setAlertModal(false)} className="bg-info-subtle text-info border-bottom-0 pb-3">
          <span className="fs-15 fw-semibold"><i className="ri-information-line me-1 align-bottom"></i> Чухал мэдэгдэл</span>
        </ModalHeader>
        <ModalBody className="text-center p-4">
          <div className="mt-2">
            <i className="ri-information-fill text-info display-4"></i>
            <h4 className="mb-3 mt-4 fw-semibold text-dark">{currentAlert?.ntf_title || "ЧУХАЛ МЭДЭГДЭЛ"}</h4>
            <p className="text-muted fs-15 mb-4">{currentAlert?.ntf_body}</p>
            <div className="mb-4">
              {currentAlert?.ntf_type === "feedback" && (
                <div className="text-start mt-3">
                  <Label className="fw-medium text-dark">Таны санал хүсэлт:</Label>
                  <Input
                    type="textarea"
                    rows="3"
                    placeholder="Энд бичнэ үү..."
                    value={fbText}
                    onChange={(e) => setFbText(e.target.value)}
                    disabled={currentAlert.recipients?.find(r => r.userId === authUser._id)?.isRead}
                  />
                </div>
              )}
              {currentAlert?.ntf_type === "poll" && currentAlert?.pollOptions?.length > 0 && (
                <div className="text-start mt-3">
                  <Label className="fw-medium text-dark">Хариулт сонгох:</Label>
                  <div className="d-flex flex-column gap-2 mt-2">
                    {currentAlert.pollOptions.map((opt, i) => (
                      <FormGroup check key={i}>
                        <Input
                          type="radio"
                          name="pollOptionsRad"
                          id={`pollOpt_${i}`}
                          value={opt}
                          checked={pollOpt === opt}
                          onChange={(e) => setPollOpt(e.target.value)}
                          disabled={currentAlert.recipients?.find(r => r.userId === authUser._id)?.isRead}
                        />
                        <Label check htmlFor={`pollOpt_${i}`}>{opt}</Label>
                      </FormGroup>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="hstack gap-2 justify-content-center">
              {currentAlert?.recipients?.find(r => r.userId === authUser?._id)?.isRead ? (
                <Button color="light" size="lg" onClick={() => setAlertModal(false)}>
                  <i className="ri-close-line align-middle me-1"></i> Хаах
                </Button>
              ) : (
                <Button color="info" size="lg" onClick={handleAcknowledgeAlert}>
                  <i className="ri-check-double-line align-middle me-1"></i> {["feedback", "poll"].includes(currentAlert?.ntf_type) ? "Илгээх & Танилцах" : "Мэдэгдэлтэй танилцсан"}
                </Button>
              )}
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Bottom-right blinking popup notifications — зөвхөн target хэрэглэгчдэд */}
      {isTargetUser && popupNotifications.length > 0 && (
        <>
          <style>{`
            @keyframes ntf-blink {
              0%, 100% { box-shadow: 0 4px 24px rgba(13,110,253,0.18); border-color: #0d6efd; }
              50% { box-shadow: 0 4px 32px rgba(13,110,253,0.55); border-color: #6ea8fe; }
            }
            .ntf-popup-card {
              animation: ntf-blink 1.6s ease-in-out infinite;
              border: 2px solid #0d6efd;
              border-radius: 12px;
              background: #fff;
              padding: 14px 16px;
              width: 320px;
              position: relative;
              font-size: 13px;
              color: #212529;
              transition: opacity 0.2s;
            }
            .ntf-popup-card:hover {
              animation-play-state: paused;
            }
            .ntf-popup-close {
              position: absolute;
              top: 8px;
              right: 10px;
              background: none;
              border: none;
              font-size: 16px;
              color: #6c757d;
              cursor: pointer;
              line-height: 1;
              padding: 0;
            }
            .ntf-popup-close:hover { color: #dc3545; }
          `}</style>
          <div style={{
            position: "fixed",
            bottom: 20,
            right: 20,
            zIndex: 99999,
            display: "flex",
            flexDirection: "column-reverse",
            gap: 10,
            maxHeight: "90vh",
            overflowY: "auto",
            overflowX: "hidden",
            paddingRight: 2,
          }}>
            <div style={{ display: "flex", gap: 6 }}>
              <button
                onClick={async () => {
                  const unreadIds = popupNotifications.map((p) => p.id).filter(Boolean);
                  if (unreadIds.length > 0) {
                    await dispatch(onGetUpdateNotification({ ids: unreadIds }));
                  }
                  setPopupNotifications([]);
                }}
                style={{
                  background: "#198754",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "5px 14px",
                  fontSize: 12,
                  cursor: "pointer",
                  flex: 1,
                }}
              >
                ✓ Бүгдийг уншсан
              </button>
              <button
                onClick={() => setPopupNotifications([])}
                style={{
                  background: "#495057",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "5px 14px",
                  fontSize: 12,
                  cursor: "pointer",
                  flex: 1,
                }}
              >
                ✕ Бүгдийг хаах
              </button>
            </div>
            {popupNotifications.map((p) => {
              const date = p.date ? new Date(p.date) : null;
              const dateStr = date
                ? `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,"0")}-${String(date.getDate()).padStart(2,"0")}, ${String(date.getHours()).padStart(2,"0")}:${String(date.getMinutes()).padStart(2,"0")}:${String(date.getSeconds()).padStart(2,"0")}`
                : "";
              return (
                <div key={p.id} className="ntf-popup-card">
                  <button
                    className="ntf-popup-close"
                    onClick={() => setPopupNotifications((prev) => prev.filter((n) => n.id !== p.id))}
                    title="Хаах"
                  >✕</button>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6, paddingRight: 20 }}>
                    <span style={{ fontSize: 20 }}>🔔</span>
                    <span style={{ fontWeight: 700, color: "#0d6efd", fontSize: 13, lineHeight: 1.3 }}>{p.title}</span>
                  </div>
                  {p.body && (
                    <div style={{ color: "#495057", marginBottom: 6, lineHeight: 1.5, fontSize: 12 }}>{p.body}</div>
                  )}
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    {p.sender && <span style={{ fontSize: 11, color: "#6c757d" }}>{p.sender}</span>}
                    {dateStr && <span style={{ fontSize: 11, color: "#adb5bd" }}>{dateStr}</span>}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default NotificationDropdown;
